import { IFormViewForm } from 'components/FormView';
const SerialNumber: { [x: string]: IFormViewForm } = {
    SerialNumberForm: {
        id: 'SerialNumberForm',
        layout: {
            rows: 1,
            columns: 2,
        },
        fields: [
            {
                id: '1',
                type: 'PAPER_CONTAINER',
                visible: true,
                props: {
                    name: 'activity',
                    fullWidth: true,
                    elevation: 0
                },
                position: {
                    row: 1,
                    col: 1
                },
                children: [
                    {
                        id: 1,
                        type: 'TEXT_FIELD',
                        props: {
                            name: 'LotSerial',
                            label: 'Starting serial',
                            placeholder: '',
                            size: 'medium',
                        },
                    },
                    {
                        id: 2,
                        type: 'TEXT_FIELD',
                        props: {
                            name: 'Quantity',
                            label: 'Quantity',
                            placeholder: '',
                            size: 'medium',
                            type: 'number',
                        },
                    },
                ]
            }
        ]
    }
};
export default SerialNumber;
